<template>
  <ul class="menu" @click="$emit('actionClicked')">
    <li class="menu__item">
      <RouterLink
        :to="{
          name: 'admin.products.packages.package.packageItems.packageItem.edit',
          params: {
            packageId: packageItem.packageId,
            packageItemId: packageItem.id,
          },
        }"
        class="menu__link capitalize"
      >
        {{ $te('edit') ? $t('global.edit') : 'edit' }}
      </RouterLink>
    </li>
    <li class="menu__item">
      <RouterLink
        :to="{
          name: 'admin.products.packages.package.packageItems.packageItem.requirements',
          params: {
            packageId: packageItem.packageId,
            packageItemId: packageItem.id,
          },
        }"
        class="menu__link capitalize"
      >
        {{ $te('requirements') ? $t('requirements') : 'requirements' }}
      </RouterLink>
    </li>
    <li class="menu__item">
      <RouterLink
        :to="{
          name: 'admin.products.packages.package.packageItems.packageItem.delete',
          params: {
            packageId: packageItem.packageId,
            packageItemId: packageItem.id,
          },
        }"
        class="menu__link capitalize"
      >
        {{ $te('delete') ? $t('delete') : 'delete' }}
      </RouterLink>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'DataIteratItemActions',
  props: {
    packageItem: {
      type: Object,
      required: true,
    },
  },
};
</script>
